export const iosPlans = [
  {
    productId: 'PFE_Only_Annual',
    duration: 'Annually',
    isOccupational: false,
  },
  {
    productId: 'PFE_SKT_Annual',
    duration: 'Annually',
    isOccupational: true,
  },
  {
    productId: 'PFE_Only_SemiAnnual',
    duration: 'SemiAnnually',
    isOccupational: false,
  },
  {
    productId: 'PFE_SKT_SemiAnnual',
    duration: 'SemiAnnually',
    isOccupational: true,
  },
];

export function getIosPlanType(productId) {
  return iosPlans.find((p) => p.productId === productId) ?? null;
}
export function getStripePlanDuration(plan) {
  if (plan.interval === 'month' && plan.interval_count === 6)
    return 'SemiAnnually';
  if (plan.interval === 'year') return 'Annually';
  return null;
}

/**
 * Upgrades that take place immediately with a prorated credit instead of
 * waiting until the end of the current period:
 * - PFE Only -> PFE+SKT
 * - Semi-Annual -> Annual, except PFE+SKT -> PFE Only
 */
export function isImmediateUpgrade(currentPlan, targetPlan) {
  const isPfeOnlyToPfeSkt =
    !currentPlan.isOccupational && targetPlan.isOccupational;
  // Semi-Annual PFE+SKT -> Annual PFE Only loses SKT content, so it is scheduled
  const isSemiToAnnual =
    currentPlan.duration === 'SemiAnnually' &&
    targetPlan.duration === 'Annually' &&
    (targetPlan.isOccupational || !currentPlan.isOccupational);
  return isPfeOnlyToPfeSkt || isSemiToAnnual;
}

export function determineIosToStripeSwitchType(iosPlan, targetPlan) {
  // blocked case (PFE annual -> SKT semi) should never reach here (it is hidden from selector)
  if (
    !iosPlan.isOccupational &&
    iosPlan.duration === 'Annually' &&
    targetPlan.isOccupational &&
    targetPlan.duration === 'SemiAnnually'
  )
    return 'blocked';

  // immediate: any pfe only -> skt (blocked case already excluded above), semi -> annual upgrades
  if (isImmediateUpgrade(iosPlan, targetPlan)) return 'immediate';

  // everything else ->scheduled
  return 'scheduled';
}

export function getIosToStripeSwitchType(iosProductId, stripePlan) {
  const iosPlan = getIosPlanType(iosProductId);
  if (!iosPlan || !stripePlan) return null;

  const duration = getStripePlanDuration(stripePlan);
  if (!duration) return null;
  const targetPlan = {
    isOccupational: stripePlan.isOccupational,
    duration,
  };
  return determineIosToStripeSwitchType(iosPlan, targetPlan);
}
